import { CONVERSATION_TYPES } from 'constants/ChatConstants';
import { uniq } from 'utils/ObjectUtils';
import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../../actionTypes';
import { addAll, prependOneAfterSend, clear } from '../utils/reducer';

const initialState = [];

const prependOne = (state, { payload: conversation }) => {
  const isNew = !state.includes(conversation.id);
  if (isNew && !(conversation.customer || conversation.customerId)) {
    return uniq([conversation.id, ...state]);
  }
  return state;
};

const prependConversationInList = (state, { payload: conversation }) => uniq([conversation.id, ...state]);

const addOneMatcher = ({ type: actionType, meta }) =>
  actionType === actionTypes.FETCH_CONVERSATIONS_SUCCESS && meta.type === CONVERSATION_TYPES.INTERNAL;

const shouldPrependInList = ({ type, payload: conversation }) =>
  type === actionTypes.PREPEND_CONVERSATION_IN_LIST && conversation.type === CONVERSATION_TYPES.INTERNAL;

export default createReducer(
  initialState,
  {
    [actionTypes.CLEAR_CONVERSATIONS]: clear,
    [actionTypes.CLEAR_INTERNAL_CONVERSATIONS]: clear,
    [actionTypes.POST_CONVERSATION_SUCCESS]: prependOne,
    [actionTypes.POST_MESSAGE_SUCCESS]: prependOneAfterSend,
  },
  [
    {
      matcher: shouldPrependInList,
      reducer: prependConversationInList,
    },
    {
      matcher: addOneMatcher,
      reducer: addAll,
    },
  ]
);
